module.exports = __webpack_public_path__ + "img/PretoriaFM-logo.aa34495a.png";